module.exports = __webpack_public_path__ + "static/assets/5d6d0bcd33400018e98424c92d4cbb67.svg";